// More here:
// http://jaketrent.com/post/addremove-classes-raw-javascript/

//Check if NodeList
Element.prototype.isNodeList = () => {
	return false;
}
NodeList.prototype.isNodeList = HTMLCollection.prototype.isNodeList = () => {
	return true;
}

const hasClass = function(el, className) {
	if (typeof(el) === 'string') {
		el = document.querySelector(el);
	}
	if (el.classList) {
		return el.classList.contains(className);
	} else {
		return !!el.className.match(new RegExp('(\\s|^)' + className + '(\\s|$)'));
	}
}
const changeClass = {

	addClass: function(el, className) {
		if (typeof(el) === 'string') {
			el = document.querySelector(el);
		}
		if (el.isNodeList()) {
			for (var i = 0; i < el.length; i++) {
				if (el[i].classList) {
					el[i].classList.add(className);
				} else if (!hasClass(el[i], className)) {
					el[i].className += " " + className;
				}
			}
		} else {
			if (el.classList) {
				el.classList.add(className);
			} else if (!hasClass(el, className)) {
				el.className += " " + className;
			}
		}
	},
	removeClass: function(el, className) {
		if (typeof(el) === 'string') {
			el = document.querySelector(el);
		}
		if (el.isNodeList()) {
			for (var i = 0; i < el.length; i++) {
				if (el[i].classList) {
					el[i].classList.remove(className)
				} else if (hasClass(el[i], className)) {
					const reg = new RegExp('(\\s|^)' + className + '(\\s|$)');
					el[i].className = el[i].className.replace(reg, ' ');
				}
			}
		} else {
			if (el.classList) {
				el.classList.remove(className)
			} else if (hasClass(el, className)) {
				const reg = new RegExp('(\\s|^)' + className + '(\\s|$)');
				el.className = el.className.replace(reg, ' ');
			}
		}
	}
}
module.exports = changeClass;



// WEBPACK FOOTER //
// ./lib/changeClass.js